import indiaProps from '../indiaProps';

export const formatCurrency = (value: number) => {
  return new Intl.NumberFormat('en-IN', { style: 'currency', currency: indiaProps.currency }).format(value);
  // return value.toLocaleString('en', indiaProps);
};

export default formatCurrency;
